import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Přihlášení proběhlo úspěšně");
      nav(u?.role === "technician" ? "/technik" : "/admin");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12" style={{ background: "#0A2540" }}>
        <div className="okenfix-brand text-3xl font-extrabold" style={{ color: "#C5A059" }}>OKENFIX</div>
        <div className="text-white max-w-md">
          <h1 className="text-4xl font-bold mb-4">Rezervace servisu oken pro SVJ</h1>
          <p className="text-slate-300 text-lg">Přehledné plánování termínů, kapacit a harmonogramu servisu pro celé společenství vlastníků.</p>
        </div>
        <p className="text-slate-400 text-sm">© 2026 OKENFIX</p>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div className="lg:hidden okenfix-brand text-2xl font-extrabold" style={{ color: "#0A2540" }}>OKENFIX</div>
          <div>
            <h2 className="text-2xl font-bold text-[#0A2540]">Přihlášení</h2>
            <p className="text-slate-500 mt-1">Superadmin, předseda SVJ nebo technik</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">E-mail nebo přihlašovací jméno</Label>
            <Input id="email" type="text" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-12" data-testid="login-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Heslo</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="h-12" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full h-12 text-base" style={{ background: "#0A2540" }}>
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Přihlásit se
          </Button>
        </form>
      </div>
    </div>
  );
}
